import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-intermediate2-fa',
  templateUrl: './intermediate2-fa.page.html',
  styleUrls: ['./intermediate2-fa.page.scss'],
})
export class Intermediate2FAPage implements OnInit {

  secretKey: any = ''
  locale: any = ''

  constructor(private formBuilder: FormBuilder, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router, private _translationService: TranslationService) { }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this._commonService.secretKey = this.route.snapshot.paramMap.get('id');
    this._commonService.tempUserName = this.route.snapshot.paramMap.get('username');
    if (localStorage.locale) {
      this._commonService.locale = Number(localStorage.locale);
      this.locale = Number(localStorage.locale);
    } else {
      this._commonService.locale = 1043;
      localStorage.locale = this._commonService.locale;
    }

    this.verify2fa()
  }

  verify2fa(){
    this._commonService.presentLoading();
    if( this._commonService.secretKey && this._commonService.tempUserName){
      this.router.navigate(['loginverification'])
    }
    this._commonService.dismiss();
  }
  
}
